<template>
  <v-card flat tile outlined :loading="!chart">
    <v-toolbar flat>
      <v-toolbar-title>Richieste per Cliente</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="8">
          <ChartTable :data="dashboardData(this.resource, this.scope_1)" />
        </v-col>
        <v-col class="text-center">
          <pie-chart
            v-if="chart"
            :messages="{ empty: 'Non ci sono dati' }"
            :data="pieChartData(scope_1)"
            :library="library"
            width="240px"
          ></pie-chart>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-btn-toggle v-model="interval" mandatory tile group>
        <v-btn value="3" small>
          3 mesi
        </v-btn>
        <v-btn value="6" small>
          6 mesi
        </v-btn>
        <v-btn value="12" small>
          12 mesi
        </v-btn>
      </v-btn-toggle>
    </v-card-actions>
  </v-card>
</template>

<script>
import dashboard from '@mixins/dashboard.js'
import ChartTable from '@components/dashboard/ChartTable.vue'

export default {
  name: 'TicketsByCustomer',
  components: { ChartTable },
  mixins: [dashboard],
  data: () => ({
    resource: 'report',
    scope_1: 'tickets_per_customer',
    interval: 3,
    options: {
      scales: {
        xAxes: [
          {
            type: 'time',
            time: {
              unit: 'month',
            },
          },
        ],
      },
    },
    library: {
      layout: {
        padding: {
          left: 16,
          right: 16,
          top: 0,
          bottom: 16,
        },
      },
      legend: { display: false, position: 'bottom' },
    },
  }),
  computed: {
    chartData() {
      const month = this.dashboardData(this.resource, this.scope_1) || []
      return [
        {
          name: 'Nuove Richieste per mese',
          data: month.reduce((acc, it) => {
            acc[it.label] = it.count
            return acc
          }, {}),
        },
      ]
    },
  },
  watch: {
    interval: {
      immediate: true,
      handler: 'getData',
    },
  },
  methods: {
    pieChartData(scope) {
      const data = this.dashboardData(this.resource, scope) || []
      return data.map((r) => [r.label, r.count])
    },
    getData() {
      this.getReportData({
        resource: this.resource,
        scope: this.scope_1,
        interval: this.interval,
      })
    },
  },
}
</script>
